import { get } from '../client';

/** Lightweight dropdown/lookup endpoints — id + name (+ code) only. */
export const lookupsApi = {
  villages: () => get('/lookups/villages'),
  equipmentTypes: () => get('/lookups/equipment-types'),
  businessUnits: () => get('/lookups/business-units'),
  sites: (params = {}) => get('/lookups/sites', { params }),
  vendors: () => get('/lookups/vendors'),
};
